import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'

export const StyledModalContent = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2)
}))

export const StyledModalActions = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2)
}))
